import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserVisitModel } from 'app/modules/configuration/definition';

@Component({
  selector: 'app-entrance-card',
  templateUrl: './entrance-card.component.html',
  styleUrls: ['./entrance-card.component.scss']
})
export class EntranceCardComponent implements OnInit {

  @Input() Users: UserVisitModel[];

  @Output() ClickCard = new EventEmitter();

  bgColors: string[] = ['ffdeee', 'ebaeae', 'fce5af', 'fcbaaa', '8cdfe2'];

  fontColors: string[] = ['bd91a7', 'a94d4d', 'c7a044', 'b34e34', '398b8e'];

  constructor() { }

  ngOnInit(): void {

  }

  clickCard() {
    this.ClickCard.emit();
  }
}
